import {useTypedSelector} from "../../../store";
import Nav, {NavProps} from "./Nav";

type Props = Omit<NavProps, "locations">;

export default function NavWithRedux(props: Props) {
  const {locations} = useTypedSelector(({config}) => config);
  return <Nav {...props} locations={locations} />;
}
